import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import Constants from "./../../Utils/Constants";

// Guards a route element behind logged-out state. Wrap the public-only element:
// <Route path={Constants.login} element={<PublicRoute><Login /></PublicRoute>} />
function PublicRoute({ children }) {
  if (AuthService.isAuthenticated()) {
    return <Navigate to={Constants.dashboard} replace />;
  }

  return children;
}

export default PublicRoute;
